/**
 * messengerWsBus — крошечная шина для ОТПРАВКИ команд в единый WebSocket
 * мессенджеров. useMessengerWs регистрирует активный сокет здесь, а композаблы
 * звонков (useTelegramCall) шлют через sendWs без прямой зависимости от
 * useMessengerWs — иначе получился бы циклический импорт (WS роутит события в
 * звонок, звонок шлёт команды в WS).
 */

let activeWs: WebSocket | null = null

/** Регистрирует/сбрасывает активный сокет (вызывается из useMessengerWs). */
export function setActiveWs(ws: WebSocket | null): void {
  activeWs = ws
}

/**
 * Отправляет команду в WS-хаб в общем конверте {code, message, result}.
 * Возвращает false, если сокет не открыт (звонок трактует это как ошибку связи).
 */
export function sendWs(code: string, result: unknown): boolean {
  if (activeWs && activeWs.readyState === WebSocket.OPEN) {
    activeWs.send(JSON.stringify({ code, message: '', result }))
    return true
  }
  return false
}
